export default __webpack_public_path__ + "static/media/congrats-completed.a8a1cbdb.svg";